import { AxiosResponse } from 'axios';
import $api from '@/http/index';

export class AiService {
    static async transformTextareaValue(
        aiAutocompleteKey: string,
        val: string,
        signal?: AbortSignal,
    ): Promise<AxiosResponse<string>> {
        return $api.post<string>(
            `/ai/transformText`,
            {
                aiAutocompleteKey: aiAutocompleteKey,
                textToTransform: val,
            },
            { signal },
        );
    }
}
